import { Link, useLocation } from 'react-router-dom';
import { Phone, MessageCircle, Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-50 w-full bg-brand-black shadow-md border-b border-brand-red">
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          {/* Abstract Crown Icon */}
          <div className="relative w-10 h-10 flex items-center justify-center bg-brand-red rounded shadow-lg">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white">
              <path d="M2 19H22V21H2V19ZM3 17L5 7L12 12L19 7L21 17H3Z" fill="currentColor" />
            </svg>
            <div className="absolute top-0 right-0 w-2 h-2 bg-brand-gold rounded-full transform translate-x-1 -translate-y-1"></div>
          </div>
          <div className="flex flex-col">
            <span className="font-heading font-bold text-xl text-white tracking-wide uppercase leading-tight">
              König
            </span>
            <span className="text-brand-gray-light text-[10px] tracking-widest uppercase">
              Rohrreinigung
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/leistungen" className="text-white hover:text-brand-red transition-colors text-sm font-medium">Leistungen</Link>
          <Link to="/standorte" className="text-white hover:text-brand-red transition-colors text-sm font-medium">Standorte</Link>
          <Link to="/preise" className="text-white hover:text-brand-red transition-colors text-sm font-medium">Preise</Link>
          <Link to="/ueber-uns" className="text-white hover:text-brand-red transition-colors text-sm font-medium">Über uns</Link>
        </nav>

        {/* CTA Buttons & Mobile Toggle */}
        <div className="flex items-center gap-3">
          <a href="https://wa.me/4915219576394" target="_blank" rel="noopener noreferrer" className="hidden sm:flex items-center justify-center w-10 h-10 bg-green-500 hover:bg-green-600 text-white rounded-full transition-colors" aria-label="WhatsApp">
            <MessageCircle className="w-5 h-5" />
          </a>
          <a href="tel:+4915219576394" className="flex items-center gap-2 bg-brand-red hover:bg-brand-red-dark text-white px-5 py-2.5 rounded shadow-lg font-bold transition-colors">
            <Phone className="w-5 h-5" />
            <span className="hidden sm:inline">+49 152 19576394</span>
            <span className="sm:hidden">Notruf</span>
          </a>
          <button aria-label="Open navigation menu" 
            className="md:hidden text-white ml-2 focus:outline-none" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-brand-black border-t border-brand-gray-dark px-4 py-4 absolute w-full left-0 shadow-xl">
          <nav className="flex flex-col gap-4">
            <Link to="/leistungen" className="text-white hover:text-brand-red transition-colors text-lg font-medium py-2 border-b border-white/10">Leistungen</Link>
            <Link to="/standorte" className="text-white hover:text-brand-red transition-colors text-lg font-medium py-2 border-b border-white/10">Standorte</Link>
            <Link to="/preise" className="text-white hover:text-brand-red transition-colors text-lg font-medium py-2 border-b border-white/10">Preise</Link>
            <Link to="/ueber-uns" className="text-white hover:text-brand-red transition-colors text-lg font-medium py-2">Über uns</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
